import { Component, Injector } from '@angular/core';
import { LoaderService } from 'src/app/loader/loader.service';
import { SharedsService } from 'src/app/shareds/shareds.service';
import { LoginService } from '../login/login.service';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-self-onboard-plans',
  templateUrl: './self-onboard-plans.component.html',
  styleUrls: ['./self-onboard-plans.component.scss'],
})
export class SelfOnboardPlansComponent {
  planList = [];
  defaultLanguage: any = 'en';
  sharedService: SharedsService;
  loginService: LoginService;
  loader: LoaderService;
  translate: TranslateService;
  showSelfOnboard = false;
  selectedSignupOption = 'self';
  loadershow = false;

  constructor(
    private readonly injector: Injector,
    private readonly router: Router,
  ) {
    this.sharedService = this.injector.get<SharedsService>(SharedsService);
    this.loader = this.injector.get<LoaderService>(LoaderService);
    this.loginService = this.injector.get<LoginService>(LoginService);
    this.translate = this.injector.get<TranslateService>(TranslateService);
    this.translate.setDefaultLang('en');
    this.translate.use(this.defaultLanguage ? this.defaultLanguage : 'en');
  }

  ngOnInit() {
    this.listPlan();
  }

  listPlan() {
    this.loadershow = true;
    this.loginService.getPlanDetails()?.subscribe({
      next: (data) => {
        if (data.info) {
          this.planList = data.info;
          this.loadershow = false;
          this.mofifyMenuPlanList();
        }
      },
      error: (err) => {
        console.error('Error listPlan:', err);
      },
    });
  }

  mofifyMenuPlanList() {
    this.planList.forEach((item) => {
      item['tabs'] = [];
      item.details?.menu?.forEach((tab) => {
        const subMenu = tab.subMenu;
        subMenu?.forEach((sub) => item['tabs'].push(sub));
      });
    });
  }

  showTemplateSignUp() {
    this.router.navigate(['/signup']);
  }
}
